<template>
  <div class="w-100 p-2 mt-2">
    <page-header>
      <b-icon-diagram2 class="mr-1"></b-icon-diagram2>
      {{ $t('page.title.tag_grid') }}
    </page-header>
    <div class="card questions sygni-grid">
      <div class="card-header">
        <h3 class="card-title">
          <strong>{{$t('title.list')}} </strong>
        </h3>
        <div class="d-flex card-header-pills float-right">
          <b-button @click="createNew" size="sm" variant="success">
            {{$t('btn.add_new')}}
          </b-button>
        </div>
      </div>
      <div class="card-body">
        <div class="row mt-2">
          <div class="col-12">

            <div class="pagination-wrapper">

              <div class="pagination-right">
                <grid-pagination :total-count="totalCount"
                                 :per-page="perPage"
                                 :current-page="currentPage"
                                 @load-items="paginationReload"></grid-pagination>
              </div> <!-- #pagination-right-->
            </div> <!-- #pagination-wrapper-->

            <div class="table-responsive">
              <b-table striped show-empty
                       :empty-text="$t('table.no_results')"
                       :busy="isBusy"
                       hover
                       head-variant="dark"
                       outlined
                       :sort-by.sync="orderColumn"
                       :sort-desc.sync="orderDirection"
                       :no-local-sorting="true"
                       :items="items"
                       :fields="fields">


                <template #cell(createdAt)="data">
                 <div>
                   {{data.value | dateFormat('YYYY-MM-DD HH:mm')}}
                 </div>
                </template>

                <template #cell(actions)="data">
                  <div class="table-action--cell">
                    <b-button variant="danger" size="sm" @click="deleteTag(data.item)" v-if="data.item.status !== 'DELETED'">
                      {{ $t('table.btn.delete') }} {{ data.value }}
                    </b-button>
                  </div>
                </template>

                <template #table-busy>
                  <div class="text-center text-danger my-2">
                    <b-spinner class="align-middle"></b-spinner>
                    <strong>{{$t('state.loading')}}</strong>
                  </div>
                </template>

              </b-table>
            </div> <!-- #table-responsive-->

            <grid-pagination :total-count="totalCount"
                             :per-page="perPage"
                             :current-page="currentPage"
                             @load-items="paginationReload"></grid-pagination>

          </div>
        </div>
      </div> <!-- #card-body-->
    </div> <!-- #card questions sygni-grid-->
  </div>
</template>

<script>





import PageHeader from "../../../../components/page/PageHeader";
import GridPagination from "../../../../components/grid/grid-pagination/GridPagination";
import GridMixin from "../../../../components/grid/GridMixin";
import Vue from "vue";
import CreateTagModal from "../components/CreateTagModal";
import alertify from "alertifyjs";

export default {
  mixins: [GridMixin],
  components: {
    PageHeader,
    GridPagination
  },
  data() {
    return {
      gridGetUrl: '/api/tag',
      orderColumn: null,
      orderDirection: true,
      fields: [
        {key: 'name', label: this.$t('table.header.tag.name')},
        {key: 'usageCount',  label: this.$t('table.header.tag.usageCount')},
        {key: 'actions', label: this.$t('table.header.actions')},
      ],
      selectOptions: {
        bulkActions: [
          {value: null, text: this.$t('table.bulk.actions')},
          {value: 'delete', text: this.$t('table.bulk.actions.delete')},
        ],
      },
      items: [],
    };
  },
  mounted() {
    this.$on('refresh-dict', () => {
      this.loadItems();
    })
  },
  methods: {
    createNew() {
      const
          ModalConstructor = Vue.extend(CreateTagModal),
          modal = new ModalConstructor({parent: this});

      modal.name = 'create-tag';
      modal.title = this.$t('modal.title.create_tag');

      modal.submit = () => {
        modal.$v.$touch();

        if (!modal.$v.$invalid) {
          this.$store.dispatch('root/postTag', modal.form).then(
              () => {
                alertify.success(this.$t('tag.add.success'));
                this.loadItems();
                modal.hideModal();
              }
          )
        }
      }

      modal.$mount();
    },
    deleteTag(tag) {
      this.$bvModal.msgBoxConfirm(this.$t('tag.delete.confirmation.title').toString()+' '+tag.name, {
        title: this.$t('tag.delete.confirmation.desc'),
        okTitle: this.$t('tag.delete.btn.confirm'),
        cancelTitle: this.$t('btn.cancel'),
        okVariant: 'danger',
      })
          .then(value => {
            if (value) {
              this.$store.dispatch('root/deleteTag',tag.id).then(() => {
                this.loadItems();
              })
            }
          });
    },
  },
  watch: {
  }
}
</script>
